import React                  from 'react'; 
import landscape              from './story.module.css';
import portrait               from './portrait.module.css'
import Newspaper_3_col        from '../components/Newspaper_3_col.jsx';
import Newspaper              from '../components/Newspaper.jsx';
import Paper                  from '../components/Paper.jsx';
import Picture                from '../components/Picture.jsx';
import {Context}              from '../services/context.js'

import pic_patent_singapore_1 from '../pictures/Patent Singapore.avif'; 
import pic_patent_US_1        from '../pictures/US patent-1.avif'; 
import pic_patent_US_2        from '../pictures/US patent-2.avif'; 
import pic_patent_India       from '../pictures/Patent India.avif'; 
import pic_patent_EU          from '../pictures/Patent EU.avif'; 
import pic_patent_Japan       from '../pictures/Patent Japan.avif'; 
import { Helmet }             from 'react-helmet';
import cx                     from 'classnames';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});

/*
const text_1  = [{header: <p className={cx_header}>From Idea to Product </p> },
{text: <p className={cx_text}>
    I am Georg Krause, an engineer, inventor, and the founder of Back-Step Blockchain Pte Ltd. I have a history in the field of computer science and cryptography.
    I learned to ask "How" questions when I see something of interest to me. 
    Passionate about technology and always looking for new ways to improve existing solutions or find new solutions.  
</p>},
  
{text: <p className={cx_text}>
  
  Driven by curiosity, I delved into the intricacies of how Bitcoin mining processes are implemented in chips and was immediately confronted by the significant 
  energy and time demands of the process.5,
</p>},

{text: <p className={cx_text}>
  My quest for a tangible prototype coincided with the challenges posed by the Covid-19 pandemic, halting development for three years. During this period, I
  contemplated the potential applications of the Back-Step Blockchain. I envisioned a system that could be utilized in various fields, such as finance, law, bussines documents
  logistics, notary documents, social media, passport, electronic money, all kind of confidential documentation, elections, news publications, 
  new trusted and spam free e-mail, personal information and more. The Back-Step Blockchain could serve as a universal trusted storage suporting all kind of application on top. 
  In 2021, I developed the Chain-In-Chain concept, akin to virtual machines (VMs). This concept allows for the creation of multiple chains, each with its own set of rules,
  enabling the Back-Step Blockchain to be utilized for various applications in different fields.  
</p>},]


const text_2  = [{header: <p className={cx_header}>The Patents </p> },
{text: <p className={cx_text}>
  Patents have been granted in Singapore, China, Japan, United States, Korea, Israel, UK, India, and in Europe under the unitary patent system. 
</p>}];
*/

const text_1 = [
  {
    header: (
      <p className={cx_header}>
        From Idea to Product
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        I’m Georg Krause—engineer, inventor, and founder of Back‑Step Blockchain Pte Ltd. I’ve spent my career in computer science and cryptography, 
        and I’ve learned to ask “how” questions whenever something piques my interest. I’m passionate about technology and always seek ways to improve existing solutions 
        or create new ones.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Driven by curiosity, I explored how Bitcoin mining is implemented in hardware and was immediately struck by its significant energy and time requirements.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        My quest to build a working prototype coincided with the COVID‑19 pandemic, which paused development for three years. 
        During that time, I envisioned countless applications for Back‑Step Blockchain—in finance, law, business logistics, 
        notary services, social media, passports, electronic payments, elections, news publications, secure email, personal data management, and more. 
        Back‑Step Blockchain can serve as a universal, trusted storage layer supporting all kinds of applications. 
        In January 2021, I introduced the Chain‑in‑Chain concept, similar to virtual machines, allowing multiple chains—each with its own rules—to run on top of 
        Back‑Step Blockchain for diverse use cases.
      </p>
    )
  }
];

const text_2 = [
  {
    header: (
      <p className={cx_header}>
        The Patents
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Patents have been granted in Singapore, China, Japan, the United States, South Korea, Israel, the United Kingdom, India, and across Europe under the Unitary Patent system.
      </p>
    )
  }
];




export class Story extends React.Component
{
    //------------------------------------------------------------------
    //  Constructor
    //------------------------------------------------------------------
    constructor(props) 
    {
      super(props);
      this.component= "";
      this.state = {content_disabled: false}
    }  
  

    //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    componentDidMount()
    {
      //console.log('Component did mount in About Us');
      //this.forceUpdate();
      window.scrollTo({top:0, left: 0, behavious: 'smooth'});
    };
   

    //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    changeVisible(mode)
    {
      this.setState({content_disabled:mode})
    }
  
    //------------------------------------------------------------------
    //  Prepare the render output
    //------------------------------------------------------------------
    render()
    { 
      if (Context.portrait)
        {
           // console.log('Portrait use cases');

            this.component = 
            <div className={portrait.backdrop}>

              <Helmet>
                <title>The Story how Back-Step Blockchain was invented</title>
                <meta name="description" content="How Bitcoin helped indirect to create a new revolutionary new underlying blockchain. Showing all the patents received." />
                <meta charset="utf-8" />
              </Helmet>

              <div className={cx_title}>
                The Back-Step Story... 
              </div>

              <div > 
                < Paper textLines = {text_1}/> 
              </div>

              <div>
                <Paper textLines = {text_2}/>
              </div>

              <div className={portrait.image}>            
                <Picture contentLines =  {[ {shadow: <img src={  pic_patent_singapore_1}   alt="Singapore Patent" />}]}/>
              </div>
              
              <div className={portrait.image}>            
                <Picture contentLines =  {[ {shadow: <img src={ pic_patent_US_1}   alt="USA Patent cover" />}]}/>
              </div>
              
              <div  className={portrait.image}>
                <Picture contentLines =  {[ {shadow: <img src={ pic_patent_US_2}   alt="USA Patent" />}]}/>
              </div>
              
              <div  className={portrait.image}>
                <Picture contentLines =  {[ {shadow: <img src={ pic_patent_India}   alt="India Patent" />}]}/>
              </div>

              <div  className={portrait.image}>
                <Picture contentLines =  {[ {shadow: <img src={ pic_patent_EU}   alt="European Patent" />}]}/>              
              </div>

              <div  className={portrait.image}>                
                <Picture contentLines =  {[ {shadow: <img src={ pic_patent_Japan}   alt="Japan Patent" />}]}/>              
              </div>

            </div>
        }
        else
        {


      this.component = 
        <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

          <Helmet>
          <title>The Story how Back-Step was created</title>
          <meta name="description" content="How Bitcoin helped indirect to create a new revolutionary new underlying blockchain. Showing all the patents received." />
          <meta charset="utf-8" />
          </Helmet>

            {! this.state.content_disabled &&
            <>
              <div className={landscape.title_location}>
                <div className={landscape.title_text}> 
                  <p>The Story of the Back-Step Blockchain</p> 
                </div>
              </div>

          <div className={landscape.container}>

                 
          <div className={landscape.item_full}> 
                < Newspaper textLines = {text_1}/> 
              </div>
  
              <div className={landscape.item_full}>
              < Paper textLines = {text_2}/>
              </div>


              <div className={landscape.item_full}>
                <img src={ pic_patent_singapore_1} width='230' alt="Singapore Patent"  /> 
              </div>
             
              <div  className={landscape.item_full}>
                <img src={ pic_patent_US_1}  width='230' alt="USA Patent cover" />
              </div>

              <div  className={landscape.item_full}>
                <img src={ pic_patent_US_2}  width='230' alt="USA Patent detail"  />
              </div>
               
              <div  className={landscape.item_full}>
                <img src={ pic_patent_India} width='230' alt="India Patent detail"  />
              </div>


              <div  className={landscape.item_full}>
                <img src={ pic_patent_EU}    width='230' alt="European Patent detail" />
              </div>

              <div  className={landscape.item_full}>                
                <img src={ pic_patent_Japan} width='230' alt="Japan Patent detail"    />
              </div>

            </div>
            </>}
         </div>
         }
      return this.component ;
    }
}  

